import { createApi } from '@reduxjs/toolkit/query/react'

import { baseApi } from './utils'

export const rentalApi = createApi({
	reducerPath: 'rental',
	...baseApi('/rental/'),
	endpoints: builder => ({
		getVehicleHistory: builder.query<void, void>({
			query: vehicleId => `vehicle/history.php?rentalVehicleId=${vehicleId}`,
		}),
	}),
})

export const { useGetVehicleHistoryQuery } = rentalApi
